import {Breakpoint} from "../types/Breakpoint";

export const breakpoints: Record<Breakpoint, string> = {
  "sm": "640px",
  "md": "768px",
  "lg": "1024px",
  "xl": "1280px",
  "2xl": "1536px",
};
